import { Injectable, Optional, OnDestroy }     from '@angular/core';
import { Router }                   from '@angular/router';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import { NotificationsService }   from 'angular2-notifications';
import {Incidence, IncidenceNotification} from "./Incidence";
import {Page} from "../../../model/page";

@Injectable()
export class IncidenceService implements OnDestroy {

  private basePath = "api/v1/incidence/";

  constructor(private http:HttpClient) {

  }

  private errorHandler(error:any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.error || error);
  }

  get(id: string):Promise<any> {
    let url = this.basePath + id;
    return this.http
      .get(url)
      .toPromise()
      .then( response => response as Incidence )
      .catch(error => this.errorHandler(error));
  }

  getPage(page=0, size=20, sort="", filter=""){
    let url = this.basePath;
    let params = new HttpParams();
    params = params.append('page', page.toString())
      .append('size', size.toString())
      .append('sort', sort)
      .append('filter', filter);
    return this.http
      .get(url, { params: params })
      .toPromise()
      .then( response => response as Page )
      .catch(error => this.errorHandler(error));
  }

  getNotifications(sergasDeviceId: any, startDate, endDate) {
    let url = this.basePath + "notification";
    let params = new HttpParams();
    params = params.append('sergasDeviceId', sergasDeviceId)
      .append('startDate', startDate)
      .append('endDate', endDate);
    return this.http
      .get(url, { params: params })
      .toPromise()
      .then( response => response as IncidenceNotification[] )
      .catch(error => this.errorHandler(error));
  }

  create(incidence: any) {
    let url = this.basePath;
    return this.http
      .post(url, incidence)
      .toPromise()
      .then(response => response as Incidence)
      .catch(error => this.errorHandler(error));
  }

  update(incidence: any) {
    let url = this.basePath;
    return this.http
      .put(url, incidence)
      .toPromise()
      .then(response => response as Incidence)
      .catch(error => this.errorHandler(error));
  }


  public ngOnDestroy(): void {
  }


}
